import * as React from "react";
const SvgXicon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, ...props }, /* @__PURE__ */ React.createElement("line", { x1: 18, y1: 6, x2: 6, y2: 18 }), /* @__PURE__ */ React.createElement("line", { x1: 6, y1: 6, x2: 18, y2: 18 }));
export default SvgXicon;
